import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import NavigationBar from "../../components/Heritage/NavigationBar";

const ancientFashionData = {
  North: [
    {
      name: "Peshwai Saree",
      image:
        "https://royalsilknethnicsarees.com/wp-content/uploads/2024/05/IMG-20240505-WA0042.jpg",
      description:
        "Royal Maharashtrian silk sarees worn during festivals and dance.",
    },
    {
      name: "Phulkari Embroidery",
      image:
        "https://s7ap1.scene7.com/is/image/incredibleindia/phulkari-1-craft-hero?qlt=82&ts=1726641396428",
      description:
        "Vibrant floral embroidery from Punjab, adorned during weddings.",
    },
    {
      name: "Angrakha",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQzlw1hsASoNxVHqJa7Gd2Wb3-0qzyIaE64-A&s",
      description: "Traditional Rajasthani overlapped garment for men.",
    },
  ],
  South: [
    {
      name: "Mysore Silk Saree",
      image:
        "https://vootbuy.in/cdn/shop/files/Beautiful_Pure_Mysore_silk_sarees_in_elegant_contrast_border_Silk_mark_certifiedNote-_Actual_colors_of_the_saree_may_slightly_vary_from_the_colors_in_the_image_due_to_camera_effects.F_7162b3fe-b6e6-441f-bb63-626d23fd0f59_1080x.jpg?v=1721640508",
      description: "Renowned for its royal look and pure silk from Karnataka.",
    },
    {
      name: "Panche & Angavastram",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXYOUy4_zzExaMjicooGolMAGwGindiQNDiw&s",
      description: "Traditional men's drape, widely worn in Tamil Nadu.",
    },
    {
      name: "Kasavu Saree",
      image:
        "https://vannamayil.com/cdn/shop/files/traditional-onam-kerala-kasavu-cotton-saree-V04128_6.jpg?v=1688489879",
      description:
        "White and gold bordered saree from Kerala, worn during Onam.",
    },
  ],
  East: [
    {
      name: "Meghalaya Jainsem",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSoj3vv9eymUG6RrPPHZUAH7j__vFlfLT5s3A&s",
      description: "A two-piece wrap-around dress worn by women of Meghalaya.",
    },
    {
      name: "Sambalpuri Saree",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWHHK8Pg1dKsrYA8OxuPeZXuqioI3vjcIcEA&s",
      description:
        "Handwoven saree from Odisha known for its intricate ikat patterns.",
    },
    {
      name: "Assamese Mekhela Chador",
      image:
        "https://i0.wp.com/grandmaslegacy.wordpress.com/wp-content/uploads/2018/04/muga_mekhela_chador.png?w=449&h=256&ssl=1",
      description: "A two-piece elegant drape, symbolic of Assamese culture.",
    },
  ],
  West: [
    {
      name: "Bandhani",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVRumByyWQAm-tYZJ-LZOVGdBbZbw2-I2BXw&s",
      description: "Tie-dye technique traditional to Gujarat and Rajasthan.",
    },
    {
      name: "Chaniya Choli",
      image:
        "https://wholetex.sgp1.cdn.digitaloceanspaces.com/full/navratri-pure-cotton-mirror-work-lehenga-choli-673.jpg",
      description:
        "Traditional festive attire for Navratri and cultural events.",
    },
    {
      name: "Nauvari Saree",
      image:
        "https://i.pinimg.com/736x/9a/44/2d/9a442d1752a0cb8efac8a4d17243b705.jpg",
      description:
        "Worn by women in Maharashtra, tucked like dhoti for mobility.",
    },
  ],
};

const AncientFashion = () => {
  return (
    <>
      <NavigationBar />
      <Container className="py-5">
        <h1 className="text-center fw-bold mb-4">
          Ancient & Traditional Fashion of Bharat 👘
        </h1>
        <p className="text-center text-muted mb-5">
          Explore regal weaves, tribal elegance, and age-old attire of the land.
        </p>

        {Object.entries(ancientFashionData).map(([region, outfits]) => (
          <div key={region} className="mb-5">
            <h3 className="mb-4 fw-semibold text-primary">{region}</h3>
            <Row>
              {outfits.map((outfit, index) => (
                <Col md={6} lg={4} key={index} className="mb-4">
                  <Card className="h-100 shadow-sm">
                    <Card.Img
                      variant="top"
                      src={outfit.image}
                      alt={outfit.name}
                      style={{ height: "250px", objectFit: "cover" }}
                    />
                    <Card.Body>
                      <Card.Title>{outfit.name}</Card.Title>
                      <Card.Text>{outfit.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Ad Block */}
            <div className="bg-light border rounded text-center p-3 mt-4">
              <strong>Ad:</strong> Join a handloom tour to see ancient textile
              crafts in action. 🇮🇳
            </div>
          </div>
        ))}
      </Container>
    </>
  );
};

export default AncientFashion;
